/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetWidgetQueryVariables = Exact<{
  widgetId: number;
  cacheTTL?: number | null | undefined;
}>;

export type GetWidgetQuery = {
  __typename: 'query_root';
  widgets_widget_by_pk:
    | {
        __typename: 'widgets_widget';
        id: number;
        club_id: number | undefined;
        content_club_id: number | undefined;
        category: string | undefined;
        title: string | undefined;
        sort: string | undefined;
        day_switch_tab: string | undefined;
        events_away_home: string | undefined;
        custom_css: string | undefined;
        settings:
          | {
              __typename: 'widgets_club_settings';
              id: number;
              background_color: string | undefined;
              font_color: string | undefined;
              color: string | undefined;
              display_scorenco_logo: boolean | undefined;
            }
          | undefined;
        team_settings:
          | {
              __typename: 'widgets_widget_team';
              widget_ptr_id: number | undefined;
              show_ranking: boolean | undefined;
              show_events: boolean | undefined;
              show_name_in_club: boolean | undefined;
              nb_events_to_show: unknown;
              display_priority: string | undefined;
            }
          | undefined;
        live_settings:
          | {
              __typename: 'widgets_widget_live';
              nb_days_update: unknown;
              live_id: number | undefined;
            }
          | undefined;
        team_detail_list:
          | Array<{
              __typename: 'teams_team_detail';
              id: number;
              logo: string | undefined;
              team_id: number | undefined;
              name_in_club: string | undefined;
              name_in_competition: string | undefined;
              club_id: number | undefined;
            }>
          | undefined;
        widget_competitions:
          | Array<{
              __typename: 'widgets_widget_has_competition';
              id: number;
              competition_id: number | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type GetTeamDetailsQueryVariables = Exact<{
  teamId: number;
  cacheTTL?: number | null | undefined;
}>;

export type GetTeamDetailsQuery = {
  __typename: 'query_root';
  teams_team_detail_by_team_id:
    | Array<{
        __typename: 'teams_team_detail';
        id: number;
        team_id: number | undefined;
        name_in_club: string | undefined;
        name_in_competition: string | undefined;
        logo: string | undefined;
        category: string | undefined;
        club_id: number | undefined;
        club:
          | Array<{
              __typename: 'clubs_club_detail';
              id: number;
              name: string | undefined;
              logo: string | undefined;
              sport:
                | {
                    __typename: 'clubs_sport';
                    id: number;
                    name: string | undefined;
                  }
                | undefined;
              club:
                | {
                    __typename: 'clubs_club';
                    id: number;
                    color_primary: string | undefined;
                    color_secondary: string | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }>
    | undefined;
  widgets_club_settings:
    | Array<{
        __typename: 'widgets_club_settings';
        id: number;
        background_color: string | undefined;
        font_color: string | undefined;
        color: string | undefined;
      }>
    | undefined;
};

export type GetTeamMembersQueryVariables = Exact<{
  teamId: number;
  cacheTTL?: number | null | undefined;
}>;

export type GetTeamMembersQuery = {
  __typename: 'query_root';
  teams_team_detail_by_team_id:
    | Array<{
        __typename: 'teams_team_detail';
        id: number;
        team_in_season:
          | {
              __typename: 'teams_team_in_season';
              id: number;
              members:
                | Array<{
                    __typename: 'teams_team_in_season_has_member';
                    id: number;
                    number: unknown;
                    public_name: string | undefined;
                    photo: string | undefined;
                    role: string | undefined;
                    is_staff: boolean | undefined;
                    captain: boolean | undefined;
                  }>
                | undefined;
            }
          | undefined;
      }>
    | undefined;
  widgets_club_settings:
    | Array<{
        __typename: 'widgets_club_settings';
        id: number;
        background_color: string | undefined;
        font_color: string | undefined;
        color: string | undefined;
      }>
    | undefined;
};

export type GetClubWidgetSettingsQueryVariables = Exact<{
  clubId: number;
  cacheTTL?: number | null | undefined;
}>;

export type GetClubWidgetSettingsQuery = {
  __typename: 'query_root';
  widgets_club_settings:
    | Array<{
        __typename: 'widgets_club_settings';
        id: number;
        theme: string | undefined;
        font_color: string | undefined;
        color: string | undefined;
        club_id: number | undefined;
        background_color: string | undefined;
      }>
    | undefined;
};

export const GetWidgetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWidget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'widgetId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cacheTTL' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '60' },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: {
                kind: 'Variable',
                name: { kind: 'Name', value: 'cacheTTL' },
              },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'widgets_widget_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'widgetId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'club_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content_club_id' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'day_switch_tab' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events_away_home' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'custom_css' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'background_color' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'font_color' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'display_scorenco_logo' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team_settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'widget_ptr_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'show_ranking' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'show_events' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'show_name_in_club' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nb_events_to_show' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'display_priority' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'live_settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nb_days_update' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'live_id' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team_detail_list' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name_in_club' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name_in_competition' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'club_id' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'widget_competitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'competition_id' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWidgetQuery, GetWidgetQueryVariables>;
export const GetTeamDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeamDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cacheTTL' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '60' },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: {
                kind: 'Variable',
                name: { kind: 'Name', value: 'cacheTTL' },
              },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teams_team_detail_by_team_id' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'args' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'team_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'team_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name_in_club' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name_in_competition' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'club_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'club' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'args' },
                      value: { kind: 'ObjectValue', fields: [] },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sport' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'club' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'color_primary' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'color_secondary' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'widgets_club_settings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'club' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'teams' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_eq' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'teamId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'background_color' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'font_color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeamDetailsQuery, GetTeamDetailsQueryVariables>;
export const GetTeamMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeamMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cacheTTL' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '60' },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: {
                kind: 'Variable',
                name: { kind: 'Name', value: 'cacheTTL' },
              },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teams_team_detail_by_team_id' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'args' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'team_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team_in_season' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'public_name' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'public_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'is_staff' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'captain' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'widgets_club_settings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'club' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'teams' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_eq' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'teamId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'background_color' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'font_color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export const GetClubWidgetSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetClubWidgetSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clubId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cacheTTL' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '120' },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: {
                kind: 'Variable',
                name: { kind: 'Name', value: 'cacheTTL' },
              },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'widgets_club_settings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'club_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'clubId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                { kind: 'Field', name: { kind: 'Name', value: 'font_color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'club_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'background_color' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClubWidgetSettingsQuery,
  GetClubWidgetSettingsQueryVariables
>;
